import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import HeadWorksSpotlight from "@/components/HeadWorksSpotlight";
import Team from "@/components/Team";
import Testimonials from "@/components/Testimonials";
import Blog from "@/components/Blog";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingBookButton from "@/components/FloatingBookButton";
import PractitionerPage from "@/components/PractitionerPage";
import { Toaster } from "@/components/ui/sonner";

const HomePage = () => {
  return (
    <main className="min-h-screen">
      <Navbar />
      <Hero />
      <Services />
      <HeadWorksSpotlight />
      <Team />
      <Testimonials />
      <Blog />
      <Contact />
      <Footer />
      <FloatingBookButton />
      <Toaster position="top-center" />
    </main>
  );
};

const BlogPage = () => {
  return (
    <main className="min-h-screen">
      <Navbar />
      <div className="pt-20">
        <Blog />
      </div>
      <Footer />
      <FloatingBookButton />
      <Toaster position="top-center" />
    </main>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/team/:slug" element={<PractitionerPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
